import React from "react";
import "../styles/styles.css";

const Error = ({ errors }) => {
    return (
        <div className="alert alert-danger" role="alert">
            {errors.map((error, index) => (
                <p className="error-p" key={index}>{error}</p>
            ))}
        </div>
    );
};

export default Error;